import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
// import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import { loadLayoutDataList } from 'reduxUtils/modules_v2/layout';
import { updatePrebidFlag } from 'helpers/ads/redux';
import { getSiteConfig } from 'reduxUtils/modules/common';
import { loadNewsListingPageData } from 'routes/landing/redux';
import Layout from 'components_v2/desktop/Layout';
import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  fireGA4Script,
} from 'utils/common';
import {
  getKeyvaluesNav,
  setAdsConfig,
  getUniqueKeywords,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
import Landing from './Landing';
import s from './Landing.scss';
import { TOI_LIVE_DOMAIN } from '../../../../constants';
// import { loadLokSabhaElectionData } from '../../../../components/ElectionV2/loksabha_redux';
// import { loadElectionData } from '../../../../components/ElectionV2/redux';

const pageName = 'NewsListing';

async function action(context, subSection) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const localParams = { 0: context.path };

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState(),
    sectionsNameList = [],
    cd8 = '';

  // const { query: { geolocation } = {} } = context;
  const isPrime = !!state.isPrime;
  let listingPageName = '';
  const urlPath = context.pathname;

  const isExcludedFromSubsecHandling = [
    '/india/g20-summit',
    '/elections/assembly-elections',
    '/elections/lok-sabha-election',
    '/sports/cricket/asia-cup',
    '/sports/tennis',
    '/world/cop-28',
    '/world/anti-war-songs',
    '/business/dontgetscammed',
    '/most-searched-products/us',
  ];
  const isCurrentPathExcludedFromSubsecHandling = isExcludedFromSubsecHandling.includes(
    urlPath,
  );

  const isMSPPage = urlPath.includes('/most-searched-products');
  const isHotPicks = urlPath.includes('/hot-picks');

  if (urlPath) {
    const pathArr = urlPath.split('/');
    if (pathArr && pathArr.length > 0 && pathArr[1]) {
      listingPageName = pathArr[1];
    }
  }

  const { pathname } = context;
  const secName = `${subSection.subsections ? subSection.subsections : ''}`;
  const secNamePath = secName ? `/${secName}` : '';
  const subsec2 = subSection.subsec2 ? subSection.subsec2 : '';
  const subsec2Path = subsec2 ? `/${subsec2}` : '';
  const subsec3 = subSection.subsec3 ? subSection.subsec3 : '';
  const subsec3Path = subsec3 ? `/${subsec3}` : '';
  const subsec4 = subSection.subsec4 ? subSection.subsec4 : '';
  const subsec4Path = subsec4 ? `/${subsec4}` : '';
  const subsec5 = subSection.subsec5 ? subSection.subsec5 : '';
  const subsec5Path = subsec5 ? `/${subsec5}` : '';
  const newParams = {
    ...localParams,
    curpg: 1,
    fullPath: isCurrentPathExcludedFromSubsecHandling
      ? context.pathname
      : `/${listingPageName}${secNamePath}${subsec2Path}${subsec3Path}${subsec4Path}${subsec5Path}`,
    isWapView: false,
    isAppView,
    isPrime,
    subSection,
    isAffiliatePage: isMSPPage,
  };
  //   const isCityHP =
  //     context.pathname && pathname.includes('/city') && !secName && !subsec2;

  //   const cardAPIPath = getCardAPI(newParams.fullPath);
  if (!state.landing.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadNewsListingPageData(newParams)),
    );
  }

  if (!isAppView && (!state.header.data || !state.footer_v2.data)) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataList(newParams)),
    );
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // Route data calls start
  // const contextParams = context.params;
  // Route data calls end

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }
  // get updated state
  state = context.store.getState();
  const seoData = _get(state, 'landing.data.meta_data.seo');
  if (_get(state, 'navigation.data.breadCrumb', undefined)) {
    sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation.data.breadCrumbs,
    );
    cd8 = getCustomDimension8(sectionsNameList);
  }

  state = context.store.getState();

  // IMAGE_VERSION.version = state.common?.siteConfig?.imageVersion || 1;
  // const electionDataPromiseArray = [];

  // if (
  //   state.landing?.data?.sections &&
  //   Array.isArray(state.landing?.data?.sections) &&
  //   state.landing?.data?.sections.length > 0 &&
  //   state.landing?.data?.sections[0]?.id === 'election_main_widget'
  // ) {
  //   if (
  //     state.landing?.data?.sections[0].tabs &&
  //     Array.isArray(state.landing?.data?.sections[0].tabs) &&
  //     state.landing?.data?.sections[0].tabs.length > 0
  //   ) {
  //     const assemblyElectionSelection = state.landing?.data?.sections[0].tabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
  //     );
  //     const lokSabhaElectionSelection = state.landing?.data?.sections[0].tabs.filter(
  //       tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
  //     );
  //     if (
  //       assemblyElectionSelection &&
  //       Array.isArray(assemblyElectionSelection) &&
  //       assemblyElectionSelection.length > 0 &&
  //       !state?.electionV2?.refreshinterval
  //     ) {
  //       const assemblyElectionUrl =
  //         state.common?.siteConfig?.assemblyElectionUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadElectionData(null, assemblyElectionUrl, false),
  //         ),
  //       );
  //     }
  //     if (
  //       lokSabhaElectionSelection &&
  //       Array.isArray(lokSabhaElectionSelection) &&
  //       lokSabhaElectionSelection.length > 0 &&
  //       !state?.lokSabhaElection?.refreshinterval
  //     ) {
  //       const loksabhaElectionUrl =
  //         state.common?.siteConfig?.loksabhaElectionUrl;
  //       electionDataPromiseArray.push(
  //         context.store.dispatch(
  //           loadLokSabhaElectionData(null, loksabhaElectionUrl, false),
  //         ),
  //       );
  //     }
  //   }
  // }

  // if (typeof window === 'undefined') {
  //   await Promise.all(electionDataPromiseArray);
  // }

  // state = context.store.getState();

  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';

  let dataAvailable = !!state.landing.data;

  if (
    state.landing.data &&
    state.landing.data.j_message &&
    !state.landing.data.sections
  ) {
    dataAvailable = false;
  }

  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }

  if (typeof window !== 'undefined') {
    if (subsec3) {
      window.categoryForGA = `WEB-AL-${listingPageName}-${subsec3}`;
    } else if (subsec2) {
      window.categoryForGA = `WEB-AL-${listingPageName}-${subsec2}`;
    } else {
      window.categoryForGA = `WEB-AL-${listingPageName}${
        secName ? `-${secName}` : ''
      }`;
    }
    if (secName === 'financial-calculators') {
      window.categoryForGA = window.categoryForGA.replace('WEB-AL', 'WEB-CL');
    }
    window.categoryForSearchGA = `WEB-TOI-CL-${listingPageName}`;
    setAdsConfig({ subSection: secName });
  }

  let gaCategory;
  if (subsec3) {
    gaCategory = `WEB-AL-${listingPageName}-${subsec3}`;
  } else if (subsec2) {
    gaCategory = `WEB-AL-${listingPageName}-${subsec2}`;
  } else {
    gaCategory = `WEB-AL-${listingPageName}${secName ? `-${secName}` : ''}`;
  }

  // key value targetting for ads
  let sSjConf = null;
  const getAdsTargetingObj = () => {
    const contextURL = `${TOI_LIVE_DOMAIN}${context.pathname}`;
    const contentUrl = _get(state, 'wu') || contextURL;
    const metaKeywords = getUniqueKeywords(
      _get(state, 'landing.data.meta_data.seo.news_keywords', undefined),
      _get(state, 'landing.data.meta_data.seo.keywords', undefined),
    );
    const navSubsecs = _get(state, 'landing.data.meta_data.navsubsecs');
    const navKeyObj = getKeyvaluesNav(navSubsecs, contentUrl);
    const adConfig = {
      Tmpl_SCN: 'listing',
      Channel: 'toi',
      ...navKeyObj,
    };
    const jarvisConfig = _get(state, 'common.siteConfig.revenue', {});
    const webInter = _get(jarvisConfig, 'webInterstitial.ros', null);
    if (webInter) {
      const webInterstitial = {
        ...jarvisConfig.webInterstitial,
        ...webInter,
      };
      sSjConf = { webInterstitial };
    }
    if (typeof window === 'undefined') {
      checkJarvisAdsConfigForSS({
        jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
        isWapView: false,
        ...adConfig,
      });
    }
    return {
      Meta_Keywords: metaKeywords,
      Content_URL: contentUrl,
      Hyp1: _get(state, 'landing.data.meta_data.specialID'),
      ...adConfig,
    };
  };
  const adsTargetingObj = getAdsTargetingObj();
  const hypVals = _get(
    state,
    'common.siteConfig.revenue.revenue_section.hyp1Vals',
    [],
  );
  //  rev widgets
  const revWidgets = _get(state, 'landing.data.revenue.widgets', {});
  let showMiniTv = !_get(revWidgets, 'skipminitv', false);
  let hideAdCude = _get(revWidgets, 'skipcube', false);

  if (pathname && pathname.includes('/business/dontgetscammed')) {
    showMiniTv = false;
    // hideAdCude = true;
  }

  const skipRevUrls = ['/hot-picks'];
  let skipRevWidgets = _get(revWidgets, 'skipAll', false);
  for (let index = 0; index < skipRevUrls.length; index += 1) {
    const affpath = skipRevUrls[index];
    if (urlPath.includes(affpath)) {
      skipRevWidgets = true;
    }
  }
  if (skipRevWidgets) {
    showMiniTv = false;
    hideAdCude = true;
  }

  if (adsTargetingObj && hypVals.includes(adsTargetingObj.Hyp1)) {
    showMiniTv = false;
    hideAdCude = true;
  }
  // end key value targetting for ads
  const getComponent = pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }

    const prebidObj = _get(
      state,
      `common.siteConfig.prebid.templates.coronavirus.web`,
    );
    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.newlisting`,
      0,
    );

    context.store.dispatch(updatePrebidFlag(prebidObj));

    let mastheadImageLogo = '';
    if (context.pathname && context.pathname === '/toi-dialogues') {
      mastheadImageLogo = '104504006';
    } else if (
      context.pathname &&
      context.pathname.includes('/gadgets-news/times-techies')
    ) {
      mastheadImageLogo = '104858780';
    }

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        adPosition="masthead"
        pageType="landing"
        showMiniTv={showMiniTv}
        hideAdCude={hideAdCude}
        miniTvV2
        hideAds={isMSPPage || isHotPicks || skipRevWidgets}
        skipAds={skipRevWidgets}
        overRideClass={s.miniTvtopband}
        // hideAdBlockerDetector //comment this to add adblocker
        // desktopAdCode={_get(
        //   state,
        //   'revenue.data.ads.layout.masthead',
        //   undefined,
        // )}
        gutterAdCode={_get(state, 'revenue.data.ads.layout.gutter', undefined)}
        hideL2Label
        l2OverrideWrapperClass="listing_l2_nav"
        mastheadImageLogo={mastheadImageLogo}
      >
        <Landing
          newsData={state.landing && state.landing.data}
          seoData={seoData}
          subSection={subSection}
          gaCategory={gaCategory}
          location={context.pathname}
          refreshTime={parseFloat(pageRefreshTime, 10)}
        />
      </Layout>
    );
  };
  if (typeof window !== 'undefined') {
    fireGA4Script();
  }
  const isNewGam = _get(revWidgets, 'isNewGam', false);

  return {
    title,
    chunks: ['landingdesktop'],
    seoData,
    status,
    component: getComponent(title),
    maxAge: 300,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    preconnectDomains: ['//tpapi.timespoints.com'],
    headTags: [...commonHeadScripts],
    skipRouteAds: isMSPPage || skipRevWidgets || isHotPicks,
    isPrime: state.isPrime,
    adsTargetingObj,
    firstfoldColumbiaJs: true,
    enableInterstitial: !!sSjConf,
    jarvisAdsConfig: sSjConf,
    skipGrxPushNotification: skipRevWidgets,
    isNewGam,
    skipColumbiaScript: _get(revWidgets, 'skipCTN', false),
    // useVariableFonts: true, // || !state.isPrime || isPrimeContent(primeId),
    // inlineFirstFoldCSS: true,
  };
}

export default action;
